// Messages for operator/shipments/StatusModal (auto-merged by lib/i18n.ts).
export const en = {
  'operator.status_modal.title': 'Update shipment status',
  'operator.status_modal.cancel': 'Cancel',
  'operator.status_modal.update': 'Update',
  'operator.status_modal.mark_delivered': 'Mark as delivered',
  'operator.status_modal.status': 'Status',
  'operator.status_modal.current': '{label} (current)',
}

export const zhTW = {
  'operator.status_modal.title': '更新貨件狀態',
  'operator.status_modal.cancel': '取消',
  'operator.status_modal.update': '更新',
  'operator.status_modal.mark_delivered': '標記為已送達',
  'operator.status_modal.status': '狀態',
  'operator.status_modal.current': '{label}（目前）',
}
